import React from "react";
import { withStyles } from "@material-ui/styles";
import clsx from "clsx";

import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";

import { displayData } from "../../utils/data";

import colors from "../../assets/style/colors";
import { Tooltip } from "@material-ui/core";

const styles = {
  legendColor: {
    display: "inline-block",
    marginRight: "10px",
    minWidth: "16px",
    width: "16px",
    height: "16px",
    borderRadius: "3px",
  },
  legendTitle: {
    color: colors.black87,
    fontWeight: 500,
  },
  legendValue: {
    fontWeight: 500,
    fontSize: "2em",
    lineHeight: "30px",
  },
  notClickableValue: {
    color: colors.black87,
  },
  clickableValue: {
    color: colors.primary,
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  legendPercentage: {
    color: colors.black87,
    marginLeft: "12px",
    fontSize: "1.142em",
  },
  valueLine: {
    display: "flex",
    alignItems: "flex-end",
    marginBottom: "5px",
  },
  iconContainer: {
    width: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "20px",
  },
  tooltip: {
    fontSize: "1em",
  },
};

const DoughnutLegend = (props) => {
  const {
    classes,
    color,
    title,
    icon,
    value,
    percentage,
    clickable = true,
    onClick,
  } = props;

  return (
    <>
      <Grid item className="flexCenter" style={{ marginTop: "6px" }}>
        <Box
          className={classes.legendColor}
          style={{ backgroundColor: color }}
        />
        {title && (
          <Box component="span" className={classes.legendTitle}>
            {props.tooltip ? (
              <Tooltip
                title={props.tooltip}
                placement="bottom"
                classes={{ tooltip: classes.tooltip }}
              >
                <span>{title}</span>
              </Tooltip>
            ) : (
              <span>{title}</span>
            )}
          </Box>
        )}
        {icon && (
          <Box component="span" className={classes.iconContainer}>
            <img
              src={icon}
              alt="icon"
              style={{ maxWidth: "40px", maxHeight: "20px" }}
            />
          </Box>
        )}
      </Grid>
      <Grid item className={classes.valueLine}>
        <Box
          component="span"
          className={clsx(classes.legendValue, {
            [classes.notClickableValue]: !clickable,
            [classes.clickableValue]: onClick,
          })}
          onClick={() => (onClick ? onClick() : null)}
        >
          {displayData(value)}
        </Box>
        <Box component="span" className={classes.legendPercentage}>
          {!Number.isNaN(percentage) && `(${percentage} %)`}
        </Box>
      </Grid>
    </>
  );
};

export default withStyles(styles)(DoughnutLegend);
